import moment from "moment";
import { CompanyModel } from "src/app/core/models/company.model";
import { ContractModel } from "../../project-request/models/contract.model";
import { ProposalModel } from "../../project-request/models/proposal.model";
import { RequestVersionModel } from "../../project-request/models/request-version.model";

export enum StatusProject {
  PROCESS = 'PROCESS',
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
  SUSPENDED = 'SUSPENDED'
}

export class ProjectModel {
  public id: number;

  public name: string;
  public description: string | null;
  public finalUsers: string | null;
  public startDate: Date;
  public estimatedFinalDate: Date;
  public estimatedDuration: number | null;
  public realDuration: number | null;
  public currency: string;
  public estimatedCost: number | null;
  public realCost: number | null;
  public availableBudget: number | null;

  public link: string | null;

  public version: number;
  public progress: number;
  public status: StatusProject;

  public uploadedFiles: any[];

  public partnerId: number | null;
  public customerId: number | null;
  public contractId: number | null;
  public proposalId: number | null;
  public projectRequestId: number | null;

  public partner: CompanyModel | null;
  public customer: CompanyModel | null;
  public contract: ContractModel | null
  public proposal: ProposalModel | null
  public projectRequest: RequestVersionModel | null

  public createdAt: Date | null;
  public updatedAt: Date | null;

  constructor($obj?: any) {
    this.id = $obj && $obj.id ? $obj.id : '#new' + moment().valueOf();

    this.name = $obj && $obj.name ? $obj.name : '';
    this.description = $obj && $obj.description ? $obj.description : '';
    this.finalUsers = $obj && $obj.finalUsers ? $obj.finalUsers : '';
    this.startDate = $obj && $obj.startDate ? new Date($obj.startDate) : new Date();
    this.estimatedFinalDate = $obj && $obj.estimatedFinalDate ? new Date($obj.estimatedFinalDate) : new Date();
    this.estimatedDuration = $obj && $obj.estimatedDuration ? $obj.estimatedDuration : null;
    this.realDuration = $obj && $obj.realDuration ? $obj.realDuration : null;
    this.currency = $obj && $obj.currency ? $obj.currency : 'EUR';
    this.estimatedCost = $obj && $obj.estimatedCost ? $obj.estimatedCost : null;
    this.realCost = $obj && $obj.realCost ? $obj.realCost : '';
    this.availableBudget = $obj && $obj.availableBudget ? $obj.availableBudget : '';

    this.link = $obj && $obj.link ? $obj.link : null;

    this.version = $obj && $obj.version ? $obj.version : 1;
    this.progress = $obj && $obj.progress ? $obj.progress : 0;
    this.status = $obj && $obj.status ? $obj.status : StatusProject.PROCESS;

    this.uploadedFiles = $obj && $obj.uploadedFiles ? $obj.uploadedFiles : [];

    this.partnerId = $obj && $obj.partnerId ? $obj.partnerId : $obj && $obj.partner ? $obj.partner.id : null;
    this.customerId = $obj && $obj.customerId ? $obj.customerId : $obj && $obj.customer ? $obj.customer.id : null;
    this.contractId = $obj && $obj.contractId ? $obj.contractId : $obj && $obj.contract ? $obj.contract.id : null;
    this.proposalId = $obj && $obj.proposalId ? $obj.proposalId : $obj && $obj.proposal ? $obj.proposal.id : null;
    this.projectRequestId = $obj && $obj.projectRequestId ? $obj.projectRequestId : $obj && $obj.projectRequest ? $obj.projectRequest.id : null;

    this.partner = $obj && $obj.partner ? new CompanyModel($obj.partner) : null;
    this.customer = $obj && $obj.customer ? new CompanyModel($obj.customer) : null;
    this.contract = $obj && $obj.contract ? new ContractModel($obj.contract) : null;
    this.proposal = $obj && $obj.proposal ? new ProposalModel($obj.proposal) : null;
    this.projectRequest = $obj && $obj.projectRequest ? new RequestVersionModel($obj.projectRequest) : null;

    this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : null;
    this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : null;
  }

  get isProcess(): boolean { return this.status === StatusProject.PROCESS ? true : false; }

}
